export default {
  upload_common: {
    required: '필수 항목입니다.',
    max_length_500: '500자 이하여야 합니다.',
    please_enter_a_number: '숫자를 입력해 주세요.',
    unexpected_error: '예기치 못한 오류가 발생했습니다.',
    temporarily_saved: '일시저장되었습니다.',
    unanswered_items: '미응답 항목이 있습니다.',
    answer_questionnaire_select: '응답할 조사표/서베이를 선택해 주세요',
    entry: '기입해 주세요.',
    target_select: '선택해 주세요.',
    value_unit: '값',
    unit: '단위',
    attach_documents: '자료 첨부하기',
    textarea_placeholder: '※기술이 필요한 경우, 또는 보충 기재할 경우는 여기에 기재해 주세요.',
    temporary_storage: '일시저장',
    submit: '제출',
    last_saved_temporary: '최종 초안 저장 일시',
    There_are_unanswered_questions: '미응답 항목이 있습니다.',
    submitted_text: '이 조사표/서베이는 제출되었습니다.',
    submitted_at: '제출 일시',
    withdrawal_of_answer: '응답 철회',
    withdrawal_accepted: '응답이 반려되었습니다.',
    help: '도움말',
    example_of_evidence: '증빙 예',
    save_temporary_answer: '조사표/서베이 일시저장하기',
    saved_temporary_answer: '응답 내용이 일시저장되었습니다.',
    submit_answer: '조사표/서베이 제출하기',
    confirm_submit_answer: '응답 중인 조사표/서베이를 제출해도 되겠습니까?',
    confirm_submit_shared_text: '\n응답 내용은 조사 의뢰 기업에 공유됩니다.',
    complete_submit_answer: '조사표/서베이가 제출되었습니다. \n협조해 주셔서 감사합니다.',
    back_answer: '응답으로 돌아가기',
    close: '닫기',
    save_temporary_answer_and_prev: '저장하고 이전으로',
    save_temporary_answer_and_next: '저장하고 다음으로',
    prev: '이전으로',
    next: '다음으로',
    question_group_question_download: '설문 다운로드',
    question_group_answer_download: '응답 다운로드',
    question_group_download_answer_csv_title: '설문・응답(CSV)',
    question_group_download_answer_csv_description: 'CSV로 응답이 다운로드됩니다',
    question_group_download_answer_pdf_title: '응답(PDF)',
    question_group_download_answer_pdf_description: 'PDF로 응답이 다운로드됩니다',
    question_group_download_scorecard_pdf_title: '설문・응답(PDF)',
    question_group_download_scorecard_pdf_description: 'PDF로 스코어가 다운로드됩니다',
    question_group_download_esg_award_svg_title: 'ESG 어워드(SVG)',
    question_group_download_esg_award_svg_description: 'SVG로 어워드가 다운로드됩니다',
    question_group_download_esg_award_pdf_title: 'ESG 어워드(PDF)',
    question_group_download_esg_award_pdf_description: 'PDF로 어워드가 다운로드됩니다',
    request_survey_withdrawal: '응답 철회 의뢰하기',
    survey_withdrawal_description: '응답 철회를 평가 의뢰 기업에게 의뢰합니다.\n철회를 원하는 이유를 아래에 기재하고, 송신해 주세요. 내용은 평가 의뢰 기업에게 표시됩니다.',
    reason_withdrawal_request: '철회 희망 이유',
    completed_withdrawal_request: '응답 철회를 의뢰했습니다. \n반려되기까지 잠시 기다려주세요.',
    send: '송신하기',
    cancel: '취소',
    balloon_title_withdrawal_request: '응답 철회를 의뢰했습니다.',
    no_survey: '조사표/서베이의 응답 의뢰가 없습니다.',
    failed_to_save_before_export: '다운로드 전의 일시저장에 실패했습니다. 입력 내용에 누락된 것이 없는지 확인해 주세요.',
    filter_unfilled_questions: '미응답만 표시하기',
    no_unfilled_questions: '미응답 설문이 없습니다.',
    move_page: '페이지 이동하기',
    confirm_move_page_message: '응답 내용이 저장되어 있지 않습니다.이대로 이동하면 데이터가 사라집니다. 저장한 후 이동하시겠습니까?',
    confirm_without_save: '저장하지 않고 이동',
    confirm_with_save: '저장하고 이동',
    error_save: '일시저장이 되지 않았습니다. 입력 내용을 확인해 주세요.',
    // there_are_no_unanswered_questions: "",
    someone_editing_survey: '편집 중인 조사표/서베이',
    unable_edit_someone_editing_survey: '해당 조사표/서베이를 응답 중인 이용자가 있으므로 현재 편집할 수 없습니다',
    user_editing_survey: '님이 편집 중',
    reference_question: {
      // see_previous_answers: "",
      previous_answers: '과거 응답 내용',
      // overwrite_with_previous_answers: "",
      submitted_at: '({submitted_at} 제출)',
      // related_question: "",
      click_to_expand: '클릭하여 전개',
      click_to_omit: '클릭하여 생략',
      // description: "",
      answer_reference_function: '응답 인계 기능',
      overwrite: '덮어쓰기',
      overwrite_confirm: '응답 중인 조사표/서베이에 과거 응답을 자동 입력합니다.\n입력한 응답이 있는 경우는 덮어쓰기됩니다.',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: '항목',
      activity_amount: '활동량',
      emission_factor: '배출계수',
      emission_amount: '배출량',
      unit_sale: '매출액 원단위',
      total: '합계',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/백만 엔',
    },
    label: {
      required_answer: '필수 응답',
      optional_answer: '임의 응답',
      conditional_required_answer: '조건 필수 응답',
      note: '비고',
      // evidence_attachments: "",
    },
    // no_available_in_pdf: "",
    // comparison_question_meta: "",
    question_group_download_answered_csv_title: '설문・응답(CSV)',
    question_group_download_answered_pdf_title: '설문・응답(PDF)',
  },
}
